export const resources = {
    result: {
        200: {
            message: 'OK',
            description: 'Požadavek byl úspěšně zpracován.'
        },
        202: {
            message: 'Přijato',
            description: 'Požadavek byl přijat ke zpracování.'
        },
        400: {
            message: 'Chybný požadavek',
            description: 'Požadavek nelze zpracovat, protože je nesprávný nebo poškozený.'
        },
        401: {
            message: 'Neautorizováno',
            description: 'Požadované ověřovací informace buď chybí, nebo nejsou pro zdroj platné.'
        },
        402: {
            message: 'Vyžadována platba',
            description: 'Nebyly splněny požadavky na platby za rozhraní API.'
        },
        403: {
            message: 'Nedostatečné oprávnění',
            description: 'Přístup k požadovanému zdroji je odepřen. Uživatel nemusí mít dostatečná oprávnění nebo nemusí mít požadovanou licenci.'
        },
        404: {
            message: 'Nenalezeno',
            description: 'Požadovaný zdroj neexistuje.'
        },
        405: {
            message: 'Metoda není povolena',
            description: 'Metoda HTTP v požadavku není u zdroje povolena.'
        },
        406: {
            message: 'Neakceptovatelné',
            description: 'Tato služba nepodporuje formát požadovaný v hlavičce HTTP Accept.'
        },
        409: {
            message: 'Konflikt',
            description: 'Aktuální stav je v rozporu s tím, co požadavek očekává. Například zadaná nadřazená složka nemusí existovat.'
        },
        410: {
            message: 'Odstraněno',
            description: 'Požadovaný prostředek již není na serveru dostupný.'
        },
        411: {
            message: 'Konflikt',
            description: 'V požadavku je vyžadována hlavička HTTP Content-Length.'
        },
        412: {
            message: 'Nesplněna předběžná podmínka',
            description: 'Předběžná podmínka uvedená v požadavku (jako je hlavička HTTP if-match) neodpovídá aktuálnímu stavu zdroje.'
        },
        413: {
            message: 'Entita požadavku je příliš velká',
            description: 'Velikost požadavku překračuje maximální limit.'
        },
        415: {
            message: 'Nepodporovaný typ média',
            description: 'Typ obsahu požadavku je ve formátu, který služba nepodporuje.'
        },
        416: {
            message: 'Nesplnitelný rozsah požadavku',
            description: 'Zadaný rozsah bajtů je neplatný nebo nedostupný.'
        },
        422: {
            message: 'Nezpracovatelná entita',
            description: 'Požadavek nelze zpracovat, protože je sémanticky nesprávný.'
        },
        423: {
            message: 'Zamčeno',
            description: 'Zdroj, ke kterému se přistupuje, je uzamčen.'
        },
        429: {
            message: 'Příliš mnoho požadavků',
            description: 'Klientská aplikace byla omezena a neměla by se pokoušet opakovat požadavek, dokud neuplyne určitý čas.'
        },
        500: {
            message: 'Interní chyba serveru',
            description: 'Při zpracování požadavku došlo k interní chybě serveru.'
        },
        501: {
            message: 'Není implementováno',
            description: 'Požadovaná funkce není implementována.'
        },
        503: {
            message: 'Služba není dostupná',
            description: 'Služba je dočasně nedostupná z důvodu údržby nebo je přetížená. Požadavek můžete opakovat po prodlevě, jejíž délka může být specifikována v HTTP hlavičce Retry-After.'
        },
        504: {
            message: 'Vypršel časový limit brány',
            description: 'Server, který se choval jako proxy, neobdržel včasnou odpověď od nadřazeného serveru, ke kterému potřeboval přístup při pokusu o dokončení požadavku.'
        },
        507: {
            message: 'Nedostatek úložiště',
            description: 'Bylo dosaženo maximální kvóty úložiště.'
        },
        509: {
            message: 'Překročen limit šířky pásma',
            description: 'Vaše aplikace byla omezena z důvodu překročení maximálního limitu šířky pásma. Vaše aplikace může požadavek opakovat znovu po uplynutí delší doby.'
        }
    }
};
